import React from 'react'
import cn from 'classnames'
import { MdClose } from 'react-icons/md'

import { IModalBodyProps } from './interface'
import './styles.scss'

const baseClass = 'modal-body-component'

const ModalBody: React.FC<IModalBodyProps> = ({
  onRequestClose = () => {},
  children,
  className,
  withoutCross = false,
  title = '',
}) => {
  const isTitleString = title && typeof title === 'string'
  const isTitleReactElement = title && React.isValidElement(title)
  return (
    <div className={cn(`${baseClass}__wrapper`, { [className]: !!className })}>
      {!withoutCross && (
        <button className={`${baseClass}__close`} onClick={() => onRequestClose()} type="button">
          <span className={`${baseClass}__cross`}>
            <MdClose />
          </span>
        </button>
      )}
      {isTitleString && <div className={`${baseClass}__title`} dangerouslySetInnerHTML={{ __html: title }} />}
      {isTitleReactElement && <div className={`${baseClass}__title`}>{title}</div>}
      {children}
    </div>
  )
}

export default ModalBody
